import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Store } from '@ngrx/store';
import { catchError, iif, map, of, switchMap } from 'rxjs';

import { RoughagePlusEnvironment } from 'src/environments/environment.model';

import {
  CustomerSettingsResponse,
  PostCustomerSettingsRequest,
} from './request-models/customer-settings.model';
import SettingsActions from '../store/settings/actions';
import SettingsSelectors from '../store/settings/selectors';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private readonly http = inject(HttpClient);
  private readonly store = inject(Store);
  private readonly environment =
    inject<RoughagePlusEnvironment>(EnvironmentInjector);

  public postCustomerSettings(data: PostCustomerSettingsRequest) {
    return this.http.post<CustomerSettingsResponse>(
      `${this.environment.API_BASE_URL}/service/dairy-advice/secure/customer-settings/app`,
      data,
    );
  }

  public getCustomerSettings() {
    return this.http.get<CustomerSettingsResponse>(
      `${this.environment.API_BASE_URL}/service/dairy-advice/secure/customer-settings/app`,
    );
  }

  public isOnboardingCompleted$ = this.store
    .select(SettingsSelectors.selectIsOnboardingCompleted)
    .pipe(
      switchMap((isOnboardingCompleted) =>
        iif(
          () => isOnboardingCompleted,
          of(true),
          this.getCustomerSettings().pipe(
            map((response) => {
              if (response) {
                this.store.dispatch(SettingsActions.setSettings({ response }));
                return true;
              } else {
                return false;
              }
            }),
            catchError(() => of(false)),
          ),
        ),
      ),
    );
}
